import { SubpageLayout2018 } from './subpageLayout';

export default function ContactUs2018() {
  return (
    <SubpageLayout2018 lang="en" title="Contact Us" page="contact_us">
      <div className="contact_us para_introduction">
        <h1>Contact Us</h1>
        <div className="contact_subhead_2">Event &amp; Awards Enquiries</div>
        <div className="contact_card_container">
          <div className="contact_card">
            +852 2564 0943
            <br />
            <a href="mailto:smartcityawards@etnet.com.hk">smartcityawards@etnet.com.hk</a>
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

